"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EButtonType;

(function (EButtonType) {
  EButtonType["BUTTON"] = "button";
  EButtonType["WINDOW_CLOSE"] = "windowClose";
  EButtonType["WINDOW_MINIMIZE"] = "windowMinimize";
  EButtonType["COMBO_UP"] = "comboUp";
  EButtonType["COMBO_UP_19X19"] = "comboUp-19x19";
  EButtonType["COMBO_UP_15X15"] = "comboUp-15x15";
  EButtonType["COMBO_DOWN"] = "comboDown";
  EButtonType["COMBO_DOWN_19X19"] = "comboDown-19x19";
  EButtonType["COMBO_DOWN_15X15"] = "comboDown-15x15";
  EButtonType["DEF_AUTO_ATTACK"] = "defAutoAttack";
  EButtonType["DEF_AUTO_ATTACK_21X21"] = "defAutoAttack-21x21";
  EButtonType["HI_AUTO_ATTACK"] = "hiAutoAttack";
  EButtonType["HI_AUTO_ATTACK_21X21"] = "hiAutoAttack-21x21";
  EButtonType["DEF_AUTO_SKILL"] = "defAutoSkill";
  EButtonType["DEF_AUTO_SKILL_21X21"] = "defAutoSkill-21x21";
  EButtonType["HI_AUTO_SKILL"] = "hiAutoSkill";
  EButtonType["HI_AUTO_SKILL_21X21"] = "hiAutoSkill-21x21";
  EButtonType["HIRING_CALL"] = "hiringCall";
  EButtonType["HIRING_CALL_26X26"] = "hiringCall-26x26";
  EButtonType["HIRING_PET_ATTACK"] = "hiringPetAttack";
  EButtonType["HIRING_PET_ATTACK_26X26"] = "hiringPetAttack-26x26";
  EButtonType["HIRING_PET_ENDING"] = "hiringPetEnding";
  EButtonType["HIRING_PET_ENDING_26X26"] = "hiringPetEnding-26x26";
  EButtonType["HIRING_PET_FOLLOW"] = "hiringPetFollow";
  EButtonType["HIRING_PET_FOLLOW_26X26"] = "hiringPetFollow-26x26";
  EButtonType["HIRING_PET_MAIN"] = "hiringPetMain";
  EButtonType["HIRING_PET_MAIN_33X22"] = "hiringPetMain-33x22";
  EButtonType["HIRING_PET_MOTIONSTOP"] = "hiringPetMotionStop";
  EButtonType["HIRING_PET_MOTIONSTOP_26X26"] = "hiringPetMotionStop-26x26";
  EButtonType["HIRING_PET_POSITION"] = "hiringPetPosition";
  EButtonType["HIRING_PET_POSITION_26X26"] = "hiringPetPosition-26x26";
  EButtonType["HIRING_REST"] = "hiringRest";
  EButtonType["HIRING_REST_26X26"] = "hiringRest-26x26";
  EButtonType["PARTY_ICON"] = "partyicon";
  EButtonType["HI_ITEM"] = "hiitem";
  EButtonType["HI_MONEY"] = "himoney";
  EButtonType["INVITE"] = "invite";
  EButtonType["TRANSFER"] = "transfer";
  EButtonType["SECESSION"] = "secession";
  EButtonType["DISSOLUTION"] = "dissolution";
  EButtonType["PARTYFIND2"] = "partyfind2";
  EButtonType["EXPULSION"] = "expulsion";
  EButtonType["DEF_MONEY"] = "defmoney";
  EButtonType["DEF_ITEM"] = "defitem";
  EButtonType["ATTACK"] = "attack";
  EButtonType["ATTACK_19X19"] = "attack-19x19";
  EButtonType["PEACE"] = "peace";
  EButtonType["PEACE_19X19"] = "peace-19x19";
  EButtonType["WALK"] = "walk";
  EButtonType["WALK_19X19"] = "walk-19x19";
  EButtonType["RUN"] = "run";
  EButtonType["RUN_19X19"] = "run-19x19";
  EButtonType["SIT"] = "sit";
  EButtonType["SIT_19X19"] = "sit-19x19";
  EButtonType["STAND"] = "stand";
  EButtonType["STAND_19X19"] = "stand-19x19";
  EButtonType["VIEW_TRANS"] = "viewTrans";
  EButtonType["VIEW_TRANS_19X19"] = "viewTrans-19x19";
  EButtonType["MAIN_MENU_CHAR"] = "mainMenuChar";
  EButtonType["MAIN_MENU_COM"] = "mainMenuCom";
  EButtonType["MAIN_MENU_ITEM"] = "mainMenuItem";
  EButtonType["MAIN_MENU_SYS"] = "mainMenuSys";
  EButtonType["POWER_ITEM_SHOP"] = "powerItemShop";
  EButtonType["SKILL_UP"] = "skillUp";
  EButtonType["MAIN_MENU_CHAR_ATTR"] = "mainMenuCharAttr";
  EButtonType["MAIN_MENU_EXIT"] = "mainMenuExit";
  EButtonType["MAIN_MENU_FRIEND"] = "mainMenuFriend";
  EButtonType["MAIN_MENU_GUILD"] = "mainMenuGuild";
  EButtonType["MAIN_MENU_HELP"] = "mainMenuHelp";
  EButtonType["MAIN_MENU_HIRING"] = "mainMenuHiring";
  EButtonType["MAIN_MENU_INVEN"] = "mainMenuInven";
  EButtonType["MAIN_MENU_MAP"] = "mainMenuMap";
  EButtonType["MAIN_MENU_OPTION"] = "mainMenuOption";
  EButtonType["MAIN_MENU_PARTY"] = "mainMenuParty";
  EButtonType["MAIN_MENU_PARTY_FIND"] = "mainMenuPartyFind";
  EButtonType["MAIN_MENU_QUEST"] = "mainMenuQuest";
  EButtonType["MAIN_MENU_SKILL"] = "mainMenuSkill";
  EButtonType["MAIN_MENU_SOCIAL"] = "mainMenuSocial";
  EButtonType["ALONE_LEFT_TAB"] = "aloneLeftTab";
  EButtonType["ALONE_RIGHT_TAB"] = "aloneRightTab";
  EButtonType["LEFT_TAB"] = "leftTab";
  EButtonType["LEFT_TAB_13X36"] = "leftTab-13x36";
  EButtonType["RIGHT_TAB"] = "rightTab";
  EButtonType["RIGHT_TAB_13X36"] = "rightTab-13x36";
  EButtonType["CRAFT"] = "craft";
  EButtonType["CMD"] = "cmd";
  EButtonType["CMD_ICON"] = "cmdIcon";
  EButtonType["CMD_RIGHT"] = "cmdRight";
  EButtonType["CMD_MAIN_EDIT"] = "cmdMainEdit";
  EButtonType["CMD_LEFT"] = "cmdLeft";
  EButtonType["CMD_TAB"] = "cmdTab";
  EButtonType["CMD_TAB_58X19"] = "cmdTab-58x19";
  EButtonType["CMD_ACTION_BIND"] = "cmdActionBind";
  EButtonType["CMD_ACTION_COORDINATES"] = "cmdActionCoordinates";
  EButtonType["CMD_ACTION_EXIT"] = "cmdActionExit";
  EButtonType["CMD_ACTION_FOLLOW"] = "cmdActionFollow";
  EButtonType["CMD_ACTION_HELP"] = "cmdActionHelp";
  EButtonType["CMD_ACTION_LOG"] = "cmdActionLog";
  EButtonType["CMD_ACTION_PRIVATE"] = "cmdActionPrivate";
  EButtonType["CMD_ACTION_REVIVAL"] = "cmdActionRevival";
  EButtonType["CMD_ACTION_TIME"] = "cmdActionTime";
  EButtonType["CMD_ACTION_TORCH"] = "cmdActionTorch";
  EButtonType["CMD_ACTION_TRADE"] = "cmdActionTrade";
  EButtonType["CMD_EMOTION_ICON_1"] = "cmdEmotionIcon1";
  EButtonType["CMD_EMOTION_ICON_2"] = "cmdEmotionIcon2";
  EButtonType["CMD_EMOTION_ICON_3"] = "cmdEmotionIcon3";
  EButtonType["CMD_EMOTION_ICON_4"] = "cmdEmotionIcon4";
  EButtonType["CMD_EMOTION_ICON_5"] = "cmdEmotionIcon5";
  EButtonType["CMD_EMOTION_ICON_6"] = "cmdEmotionIcon6";
  EButtonType["CMD_EMOTION_ICON_7"] = "cmdEmotionIcon7";
  EButtonType["CMD_EDIT"] = "cmdEdit";
  EButtonType["OPTION"] = "option";
  EButtonType["OPTION_TAB"] = "optionTab";
  EButtonType["SYS_OPTION"] = "sysOption";
  EButtonType["LEFT_ARROW"] = "leftArrow";
  EButtonType["RIGHT_ARROW"] = "rightArrow";
  EButtonType["MY_OK"] = "myOk";
  EButtonType["OPPOSITE_OK"] = "oppositeOk";
  EButtonType["HIRING_TRADE"] = "hiringTrade";
  EButtonType["QUEST_COMMUNITY_NPC"] = "questCommunityNpc";
  EButtonType["PRIVATE_SHOP"] = "privateShop";
  EButtonType["INVENT_L_CHANGE"] = "inventLChange";
  EButtonType["INVENT_R_CHANGE"] = "inventRChange";
  EButtonType["PC_ADD"] = "pcAdd";
  EButtonType["PC_ATTR"] = "pcAttr";
  EButtonType["PARTY_FIND"] = "partyFind";
  EButtonType["PARTY_FIND_SEL"] = "partyFindSel";
  EButtonType["MSG"] = "msg";
  EButtonType["QUEST_TV"] = "questTv";
  EButtonType["QUEST_USER"] = "questUser";
  EButtonType["MM_WORLDMAP"] = "mmWorldmap";
  EButtonType["MM_EXTEND"] = "mmExtend";
  EButtonType["MM_SHRINK"] = "mmShrink";
  EButtonType["MM_ERASER"] = "mmEraser";
  EButtonType["MM_PEN"] = "mmPen";
  EButtonType["MM_PIN_HIDE"] = "mmPinHide";
  EButtonType["MM_PIN_SHOW"] = "mmPinShow";
  EButtonType["LAUNCHER_BACK"] = "launcherBack";
  EButtonType["LAUNCHER_FILECHK"] = "launcherFileChk";
  EButtonType["LAUNCHER_WEBSITE"] = "launcherWebsite";
  EButtonType["LAUNCHER_REGISTRATION"] = "launcherRegistration";
  EButtonType["LAUNCHER_LOGIN"] = "launcherLogin";
  EButtonType["LAUNCHER_MANAGEMENT"] = "launcherManagement";
  EButtonType["PS"] = "ps";
  EButtonType["PM"] = "pm";
  EButtonType["PM_SAVE"] = "pmSave";
  EButtonType["MONEY_OK"] = "moneyOk";
  EButtonType["MONEY"] = "money";
  EButtonType["BILLING"] = "billing";
  EButtonType["BILLING_CHARGING"] = "billingChargin";
  EButtonType["BILLING_HISTORY"] = "billingHistory";
  EButtonType["BILLING_TAB"] = "billingTab";
  EButtonType["BILLING_MAIN_NUMBER_1"] = "billingMainNumber1";
  EButtonType["BILLING_MAIN_NUMBER_2"] = "billingMainNumber2";
  EButtonType["BILLING_MAIN_NUMBER_3"] = "billingMainNumber3";
  EButtonType["FRIEND"] = "friend";
  EButtonType["GUILD_MARK_SELECT"] = "guildMarkSelect";
  EButtonType["GUILD_SELECT"] = "guildSelect";
  EButtonType["GUILD"] = "guild";
  EButtonType["GUILD_BACK"] = "guildBack";
  EButtonType["GUILD_MARK"] = "guildMark";
  EButtonType["GUILD_TEST"] = "guildTest";
  EButtonType["PVP_INFO_MAP"] = "pvpInfoMap";
  EButtonType["PVP_INFO_MATCH"] = "pvpInfoMatch";
  EButtonType["HELP_CENTER"] = "helpCenter";
  EButtonType["HELP_LEFT"] = "helpLeft";
  EButtonType["HELP_NO_SEL"] = "helpNoSel";
  EButtonType["HELP_RIGHT"] = "helpRight";
  EButtonType["CHAT_DAMAGE"] = "chatDamage";
  EButtonType["CHAT_GENERAL"] = "chatGeneral";
  EButtonType["CHAT_GUILD"] = "chatGuild";
  EButtonType["CHAT_PARTY"] = "chatParty";
  EButtonType["CHAT_SHOUT"] = "chatShout";
  EButtonType["CHAT_SYSTEM"] = "chatSystem";
  EButtonType["CHAT_WHISPER"] = "chatWhisper";
  EButtonType["HIRING_RECOM"] = "hiringRecom";
  EButtonType["HIRING_RECOM_42X15"] = "hiringRecom-42x15";
  EButtonType["CN"] = "cn";
  EButtonType["CN_192X32"] = "cn-192x32";
  EButtonType["GUILD_BASE1"] = "guildBase1";
  EButtonType["GUILD_BASE1_116X17"] = "guildBase1-116x17";
  EButtonType["GUILD_BASE1_230X26"] = "guildBase1-230x26";
  EButtonType["GUILD_BASE1_345X39"] = "guildBase1-345x39";
  EButtonType["GUILD_BASE2"] = "guildBase2";
  EButtonType["GUILD_BASE2_116X17"] = "guildBase2-116x17";
  EButtonType["GUILD_BASE3"] = "guildBase3";
  EButtonType["GUILD_BASE3_116X17"] = "guildBase3-116x17";
  EButtonType["GUILD_BASE4"] = "guildBase4";
  EButtonType["GUILD_BASE4_116X17"] = "guildBase4-116x17";
  EButtonType["GUILD_BASE_SELECT"] = "guildBaseSelect";
  EButtonType["GUILD_LIST"] = "guildList";
  EButtonType["MARK"] = "mark";
  EButtonType["NEW_PARTY"] = "newParty";
  EButtonType["NEW_PARTY_55X27"] = "newParty-55x27";
  EButtonType["PVP_INFO"] = "pvpInfo";
  EButtonType["SKILL_MAIN"] = "skillMain";
  EButtonType["SKILL_MAIN_40X20"] = "skillMain-40x20";
  EButtonType["SKILL_MENU_DOWN"] = "skillMenuDown";
  EButtonType["SKILL_MENU_UP"] = "skillMenuUp";
  EButtonType["STAT_DEF"] = "statDef";
  EButtonType["VENDER_TAB"] = "venderTab";
  EButtonType["VENDER_TAB_300X100"] = "venderTab-300x100";
  EButtonType["LOBBY_EXIT"] = "lobbyExit";
  EButtonType["LEFT"] = "left";
  EButtonType["RIGHT"] = "right";
  EButtonType["SELECT"] = "select";
  EButtonType["AUTO_DISPATCH"] = "autoDispatch";
  EButtonType["CHAR_CENTER_ROTATION"] = "charCenterRotation";
  EButtonType["CHAR_LEFT_ROTATION"] = "charLeftRotation";
  EButtonType["CHAR_RIGHT_ROTATION"] = "charRightRotation";
  EButtonType["GENDER_FEMALE"] = "genderFemale";
  EButtonType["GENDER_MALE"] = "genderMale";
  EButtonType["RACE_SELECT"] = "raceSelect";
  EButtonType["NAME"] = "name";
  EButtonType["CLASS_IMG_ARCHER"] = "classImgArcher";
  EButtonType["CLASS_IMG_CLERIC"] = "classImgCleric";
  EButtonType["CLASS_IMG_KNIGHT"] = "classImgKnight";
  EButtonType["CLASS_IMG_NECROMANCER"] = "classImgNecromancer";
  EButtonType["CLASS_IMG_PALADIN"] = "classImgPaladin";
  EButtonType["CLASS_IMG_SUMMONER"] = "classImgSummoner";
  EButtonType["CLASS_IMG_TRIANGLE"] = "classImgTriangle";
  EButtonType["CLASS_IMG_WARRIOR"] = "classImgWarrior";
  EButtonType["CLASS_IMG_WIZARD"] = "classImgWizard";
})(EButtonType || (EButtonType = {}));

var _default = EButtonType;
exports.default = _default;